import React, { memo, useState, useCallback, useMemo } from "react";

// styles
import {
    StyledWrapper,
    TabWrapper,
    StyledText,
    CollapsibleHeader,
    CollapsibleContent,
    ChevronIcon,
    ChevronRight,
    Icon,
    IconAndTitleWrapper,
    TitleText,
} from "./styles";

// types
import { ITabBarItem } from "@swiggy-private/dls-web-core/dist/components/TabContainer/components/TabBar/types";
import { SingleTabMeta } from "@swiggy-private/cart-types";

// constants
import { DELIVERY_INSTRUCTIONS } from "@cart-client/constants/CartDeliveryInstruction";
import { DELIVERY_INSTRUCTIONS_ICON } from "./constants";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";

interface SingleTabProps {
    renderContent: (tabItem: ITabBarItem) => React.ReactNode;
    tabOptions: ITabBarItem[];
    isPopCart?: boolean;
    tabMeta: SingleTabMeta;
}

function SingleTab({ renderContent, tabOptions, isPopCart, tabMeta }: SingleTabProps) {
    /*
       here i have not used x-channel === "toing-app"
       check becasuse canCollapse will only be true for single tab
    */
    const isCollapsibleSingleTab = tabMeta.isCollapsible && !isPopCart;

    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [rotation, setRotation] = useState(0);

    const collapsibleHeaderTitle = useMemo(() => {
        return isEmpty(tabMeta?.title) ? tabOptions?.[0]?.label : tabMeta?.title;
    }, [tabMeta, tabOptions]);

    const handleToggle = useCallback(() => {
        setIsExpanded(!isExpanded);
        setRotation(rotation + 180);
    }, [isExpanded, rotation]);

    if (isCollapsibleSingleTab) {
        return (
            <TabWrapper isPopCart={isPopCart} isCollapsed={!isExpanded}>
                <CollapsibleHeader onClick={handleToggle}>
                    <IconAndTitleWrapper>
                        <Icon
                            cloudinaryId={tabMeta?.icon || DELIVERY_INSTRUCTIONS_ICON}
                            alt=""
                            width="20px"
                            height="20px"
                        />
                        <TitleText
                            variant="V2.body2.neutral.medium"
                            color="text_High_Emphasis"
                            isCollapsible={isCollapsibleSingleTab}
                        >
                            {collapsibleHeaderTitle}
                        </TitleText>
                    </IconAndTitleWrapper>
                    <ChevronIcon isExpanded={isExpanded} currentRotation={rotation}>
                        <ChevronRight />
                    </ChevronIcon>
                </CollapsibleHeader>
                <CollapsibleContent isExpanded={isExpanded}>
                    <StyledWrapper>{renderContent(tabOptions[0])}</StyledWrapper>
                </CollapsibleContent>
            </TabWrapper>
        );
    }

    return (
        <TabWrapper isPopCart={isPopCart}>
            <StyledText variant="V2.overline.neutral.bold" color="text_Low_Emphasis">
                {isPopCart ? DELIVERY_INSTRUCTIONS : tabOptions?.[0]?.label}
            </StyledText>
            <StyledWrapper>{renderContent(tabOptions[0])}</StyledWrapper>
        </TabWrapper>
    );
}

export default memo(SingleTab);
